import { useAppSelector } from '../redux';
import { selectFeaturesEnabled } from '../features/AuthSlice/AuthSelectors';
export function useIsUngated(gate) {
  const featuresEnabled = useAppSelector(selectFeaturesEnabled);
  return featuresEnabled.includes(gate);
}